import React from 'react'
import { connect } from 'react-redux'
import { IBet, IUser } from 'client/types'
import SettledBet from './SettledBet'
import styles from './styles.module.scss'

const SettledBetGroup: React.FC<{ bets: Array<IBet>, user: IUser }> = (props) => {
  const totalWinnings = props.bets.reduce((total, bet) => {
    const isCreator = bet.createdBy._id === props.user._id
    const didCreatorWin = bet.didCreatorWin
    if (isCreator && didCreatorWin) {
      return total + bet.payout
    } else if (!isCreator && !didCreatorWin) {
      return total + bet.opposingPayout
    } else {
      return total
    }
  }, 0)

  const totalLosses = props.bets.reduce((total, bet) => {
    const isCreator = bet.createdBy._id === props.user._id
    const didCreatorWin = bet.didCreatorWin
    if (isCreator && !didCreatorWin) {
      return total + bet.opposingPayout
    } else if (!isCreator && didCreatorWin) {
      return total + bet.payout
    } else {
      return total
    }
  }, 0)

  const net = totalWinnings - totalLosses

  // @TODO assume 5% for now
  const juiceSaved = (Math.abs(totalWinnings) + Math.abs(totalLosses)) * 0.05

  return (
    <div className={styles.betGroup}>
      <div className={styles.betGroup__head}>
        <div>Date</div>
        <div>Pick</div>
        <div>Risk</div>
        <div>To Win</div>
        <div>Against</div>
      </div>
      <div className={styles.betGroup__body}>
        {props.bets.map(bet =>
          <SettledBet bet={bet} key={bet._id} />
        )}
      </div>
      <div className={styles.betGroup__footer}>
        <div>Wager History</div>
        <div>
          <span>Wagers:</span>
          <span>{props.bets.length}</span>
        </div>
        <div>
          <span>Winnings:</span>
          <span>${totalWinnings.toFixed(2)}</span>
        </div>
        <div>
          <span>Losses:</span>
          <span>${totalLosses.toFixed(2)}</span>
        </div>
        <div>
          <span>Net:</span>
          <span className={`${net >= 0 ? styles.greenText : styles.redText}`}>${Math.abs(net).toFixed(2)}</span>
        </div>
        <div>
          <span>Juice saved:</span>
          <span>${juiceSaved.toFixed(2)}</span>
        </div>
      </div>
    </div>
  )
}

const mapStateToProps = ({ auth }) => ({
  user: auth.user
})

export default connect(
  mapStateToProps,
)(SettledBetGroup)
